export default __webpack_public_path__ + "static/media/pin-orange.f06f144e.svg";